<template>
  <div class="header-reporter">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'HeaderReporter',
  mounted() {
    this.reportHeight();
    this.addListener();
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    addListener() {
      window.addEventListener('resize', this.reportHeight);
    },
    removeListener() {
      window.removeEventListener('resize', this.reportHeight);
    },
    reportHeight() {
      this.$nextTick(() => {
        if (!this.$el) return;
        const navbar = this.$children.filter(child => child.$options.name === 'Navbar').shift();

        this.$store.dispatch('navbar/setHeight', {
          navbar: navbar ? navbar.$el.offsetHeight : 0,
          promoBar: this.$el.offsetHeight,
        });
      });
    }
  }
}
</script>